import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import useAxios from "../../helpers/Hooks/useAxios";
import { URLS } from "../../helpers/URLS";
import MyReview from "./MyReview";
import TeamReviews from "./TeamReviews";
import Configure from "./Configure";
import Reports from "./Reports";
import "../../assets/scss/tables.scss";
import "./Performance.scss";

const Panel = ({ children, value, index }) => (
    <div role="tabpanel" hidden={value !== index}
        id={`performance-panel-${index}`}
        aria-labelledby={`performance-tab-${index}`}>
        {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
);

const Performance = () => {

    const { fetchData } = useAxios();

    const [value, setValue] = useState(0);
    const [access, setAccess] = useState({ canConfigure: false, isManager: false });

    /* the server decides who sees what — a tab hidden here is also refused
       by the API, so this is presentation rather than protection */
    useEffect(() => {
        const load = async () => {
            const resp = await fetchData({ url: URLS.reviewAccess, method: "get" });
            if (resp?.data) setAccess(resp.data);
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const tabs = [
        { label: "My Review", icon: <PersonOutlineRoundedIcon />, node: <MyReview />, show: true },
        { label: "Team Reviews", icon: <GroupsOutlinedIcon />, node: <TeamReviews />, show: access.isManager },
        { label: "Configure", icon: <TuneRoundedIcon />, node: <Configure />, show: access.canConfigure },
        { label: "Reports", icon: <InsightsOutlinedIcon />, node: <Reports />, show: access.canConfigure },
    ].filter((t) => t.show);

    return (
        <div className="wh-table performance-page">
            <Tabs value={Math.min(value, tabs.length - 1)} onChange={(e, v) => setValue(v)}
                aria-label="performance" variant="scrollable" scrollButtons="auto"
                className="wh-tabs">
                {tabs.map((tab, i) => (
                    <Tab key={tab.label} label={tab.label} disableRipple
                        icon={tab.icon} iconPosition="start"
                        id={`performance-tab-${i}`} aria-controls={`performance-panel-${i}`} />
                ))}
            </Tabs>

            {tabs.map((tab, i) => (
                <Panel key={tab.label} value={Math.min(value, tabs.length - 1)} index={i}>
                    {tab.node}
                </Panel>
            ))}
        </div>
    );
};

export default Performance;
